<!-- BannerComponent.vue (Vue 2 兼容) -->
<template>
  <div class="banner-container">
    <div>
      <el-tag v-for="(word,index) in config.hotWords" :key="index" type="info" style="margin-right: 10px;margin-bottom: 10px">{{ word }}</el-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HotSearchComponent',
  props: {
    config: {
      type: Object,
      default: () => ({

      })
    }
  },
  data() {
    return {

    }
  },
  watch: {
    config: {
        handler(newVal) {
          console.log(newVal);
        },
        deep: true
      }
  },
  mounted() {
    //console.log(this.config);
  },
  methods: {

  },
}
</script>

<style scoped>
.banner-container {
  border: 1px dashed #ddd;
  padding: 10px;
  border-radius: 4px;
  margin: 10px 0;
}

.carousel-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}

.img-url {
  font-size: 12px;
  color: #888;
  text-align: center;
  padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/HotSearchComponent.vue